/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import classnames from 'classnames';

import './styles.scss';

export const PageContainer = ({ children, ...props }) => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        // Hack to fix side by side images to be full width
        const image = document.querySelector('.page-wrap > .rich-text > .side-by-side:first-child.image-right img');
        if (image) {
            image.srcset = '';
        }
    });

    return <div className={classnames('page-wrap', props.className)}>{children}</div>;
};
